import { Box, Typography } from '@mui/material'
import { Info20Regular, Warning20Regular, CheckmarkCircle20Regular } from '@/components/Icon'

/** Map callout types to MUI palette keys (semantic colors). */
const typeMap = {
  info: { icon: Info20Regular, palette: 'info', bg: 'rgba(0, 120, 212, 0.08)', border: 'rgba(0, 120, 212, 0.2)' },
  warning: { icon: Warning20Regular, palette: 'warning', bg: 'rgba(216, 59, 1, 0.08)', border: 'rgba(216, 59, 1, 0.2)' },
  success: { icon: CheckmarkCircle20Regular, palette: 'success', bg: 'rgba(16, 124, 16, 0.08)', border: 'rgba(16, 124, 16, 0.2)' },
}

const CalloutBlock = ({ type = 'info', content }) => {
  const config = typeMap[type] || typeMap.info
  const Icon = config.icon

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '8px',
        bgcolor: config.bg,
        borderRadius: '8px',
        p: '10px 12px',
        my: '8px',
        border: `1px solid ${config.border}`,
      }}
    >
      <Box component="span" sx={{ display: 'inline-flex', flexShrink: 0, mt: '2px', color: `${config.palette}.main` }}>
        <Icon />
      </Box>
      <Typography variant="body2" sx={{ color: 'text.primary', m: 0 }}>
        {content}
      </Typography>
    </Box>
  )
}

export default CalloutBlock
